export enum ControlDivider {
  Comma = 'comma',
  Slash = 'slash',
}
